module.exports = __webpack_public_path__ + "static/hand2-06ee899b77a79d77cf07ab0079c8b872.png";